import React, { useEffect, useState } from 'react';
import './consultas.css';
import { initializeApp } from 'firebase/app';
import { getFirestore, doc, getDoc } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyB5l5Bpnh7VeuEfw0li3DbJ9kjTPZPNjGg",
  authDomain: "ssdiyd-f96c9.firebaseapp.com",
  projectId: "ssdiyd-f96c9",
  storageBucket: "ssdiyd-f96c9.firebasestorage.app",
  messagingSenderId: "948041839084",
  appId: "1:948041839084:web:ea010158fca5b7671650c9"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const FCartesanos = () => {

  const [folio, setFolio] = useState('');
  const [resultado, setResultado] = useState('');
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const verificarFolio = async () => {
    const folioLimpio = folio.trim().toUpperCase();

    if (folioLimpio.length !== 18) {
      setResultado('⚠️ La CURP debe tener exactamente 18 caracteres.');
      return;
    }

    setCargando(true);
    setResultado('');

    try {
      const docRef = doc(db, 'fcartesanos', folioLimpio);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const datos = docSnap.data();
        
        const mensaje = `✅ Persona Beneficiaria, ¡Felicidades!`;
        
        setResultado(mensaje);
      } else {
        setResultado('❌ Persona No Beneficiaria, Agradecemos tu participación.');
      }

    } catch (error) {
      console.error('Error:', error);
      setResultado('⚠️ Ocurrió un error al consultar. Intenta de nuevo más tarde.');
    } finally {
      setCargando(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') verificarFolio();
  };

  return (
    <div
      className='container-full-width'
      style={{
        backgroundImage: `url('https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/Tzuhu_BG.png')`,
        backgroundSize: '95%',
        backgroundPosition: 'top center',
        backgroundRepeat: 'repeat',
        minHeight: '100vh'
      }}
    >
      <div className='row'>
        <div className='col-12'>

          <h4
            className='title'
            style={{
              color: 'white',
              fontWeight: 'bold',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
            Fomento a la Capacitación de las Personas Artesanas
        <br />
          </h4>

          <p
            style={{
              color: 'white',
              fontWeight: 'bold',
              textAlign: 'center',
              fontSize: '18px',
              marginTop: '-10px',
              textShadow: '2px 2px 6px rgba(0,0,0,0.7)'
            }}
          >
           Consulta tu resultado<br />
          </p>

          <div style={{ textAlign: 'center', margin: '20px' }}>
            <input
              type="text"
              placeholder="Ingresa tu CURP"
              value={folio}
              onChange={(e) => setFolio(e.target.value)}
              onKeyPress={handleKeyPress}
              maxLength={18}
              disabled={cargando}
              style={{
                padding: '10px',
                borderRadius: '5px',
                border: 'none',
                marginRight: '10px',
                textTransform: 'uppercase'
              }}
            />

            <button
              onClick={verificarFolio}
              disabled={cargando}
              style={{
                padding: '10px 20px',
                backgroundColor: cargando ? '#666' : '#8B0000',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: cargando ? 'not-allowed' : 'pointer'
              }}
            >
              {cargando ? 'Consultando...' : 'Consultar'}
            </button>

            {resultado && (
              <div style={{ 
                marginTop: '20px', 
                color: 'white',
                textShadow: '2px 2px 6px rgba(0,0,0,0.7)',
                padding: '20px',
                backgroundColor: resultado.includes('✅') ? 'rgba(65, 12, 26, 0.48)' : 
                                 resultado.includes('❌') ? 'rgba(139,0,0,0.7)' : 
                                 'rgba(255,165,0,0.7)',
                borderRadius: '10px',
                maxWidth: '800px',
                margin: '20px auto',
                lineHeight: '1.6',
                fontSize: '16px',
                whiteSpace: 'pre-line',
                textAlign: 'left'
              }}>
                {resultado}
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default FCartesanos;